export default __webpack_public_path__ + "static/media/portrait_black.713ac398.png";